import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=68bb4289&lang=sass"

const __exports__ = script;

export default __exports__